import React, { useState, useEffect } from "react";
import md5 from "md5";
import Cookies from "universal-cookie";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../css/Login.css";

function Login() {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const cookies = new Cookies();
  const navigate = useNavigate();

  const [form, setForm] = useState({ usuario: "", contrasena: "" });
  const [loading, setLoading] = useState(false);
  const [verContrasena, setVerContrasena] = useState(false);

  // ─── Capturar inputs ────────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // ─── Enter para iniciar sesión ──────────────────────────────────────────────
  const handleKeyDown = (e) => {
    if (e.key === "Enter") iniciarSesion();
  };

  // ─── Iniciar sesión ─────────────────────────────────────────────────────────
  const iniciarSesion = async () => {
    if (!form.usuario || !form.contrasena) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        title: "Completa usuario y contraseña.",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/Usuarios/IniciarSesion`, {
        nombreUsuario: form.usuario,
        contrasena:    md5(form.contrasena),   // se hashea en MD5 antes de enviar
      });

      const data = response.data;

      // Guardar datos en cookies
      cookies.set("idUsuario",        data.idUsuario,        { path: "/" });
      cookies.set("nombreUsuario",    data.nombreUsuario,    { path: "/" });
      cookies.set("nombresApellidos", data.nombresApellidos, { path: "/" });
      cookies.set("correo",           data.correo,           { path: "/" });
      cookies.set("perfilId",         data.perfilId,         { path: "/" });
      cookies.set("perfil",           data.perfil,           { path: "/" });

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: `¡Bienvenido, ${data.nombresApellidos?.split(" ")[0]}!`,
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });

      navigate("/inicio");

    } catch (error) {
      const mensaje = error.response?.data?.mensaje || "Error al iniciar sesión. Intenta de nuevo.";
      Swal.fire({
        icon: "error",
        title: "Acceso denegado",
        text: mensaje,
        confirmButtonColor: "#2c3136",
      });
    } finally {
      setLoading(false);
    }
  };

  // ─── Redirigir si ya está logueado ─────────────────────────────────────────
  useEffect(() => {
    if (cookies.get("idUsuario")) {
      navigate("/inicio");
    }
  }, []);

  // ─── Render ─────────────────────────────────────────────────────────────────
  return (
    <div className="login-bg d-flex justify-content-center align-items-center vh-100">
      <div className="login-box card shadow-lg p-4">

        {/* Logo y título */}
        <div className="text-center mb-4">
          <img
            src="../dist/img/power.png"
            alt="Agent IA Logo"
            style={{ width: "37%" }}
          />
          <h3 className="mt-3">Iniciar sesión</h3>
          <p className="text-muted small mb-0">Ingresa tus credenciales para continuar</p>
        </div>

        {/* Formulario */}
        <div>
          {/* Usuario */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Usuario</label>
            <input
              type="text"
              name="usuario"
              className="form-control"
              placeholder="Ingresa tu usuario"
              autoComplete="off"
              maxLength={50}
              value={form.usuario}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </div>

          {/* Contraseña con ojo */}
          <div className="mb-4">
            <label className="form-label fw-semibold">Contraseña</label>
            <div className="login-input-group">
              <input
                type={verContrasena ? "text" : "password"}
                name="contrasena"
                className="form-control login-pass-input"
                placeholder="Ingresa tu contraseña"
                autoComplete="new-password"
                maxLength={50}
                value={form.contrasena}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
              />
              <button
                type="button"
                className="login-eye-btn"
                tabIndex={-1}
                onClick={() => setVerContrasena(!verContrasena)}
              >
                <i className={`fas ${verContrasena ? "fa-eye-slash" : "fa-eye"}`}></i>
              </button>
            </div>
          </div>

          {/* Botón */}
          <button
            type="button"
            className="btn btn-primary w-100 login-btn"
            onClick={iniciarSesion}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Verificando...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt me-2"></i>
                 &nbsp;&nbsp;Entrar
              </>
            )}
          </button>
        </div>

        <footer className="text-center mt-4 text-muted small">
          &copy; 2026 PowerSoft Designs. <br></br> Todos los derechos reservados.
        </footer>
      </div>

      {/* Texto esquina inferior derecha */}
      <div className="login-footer-brand">
        <strong>CRM PowerSoft Designs</strong><br />
        Tecnología inteligente para gestionar tus clientes.
      </div>
    </div>
  );
}

export default Login;